<template>
  <a-space direction="vertical">
    <template v-for="(item, index) in props.requestConfig.num">
      <!-- <a-select
        :options="selectOption"
        v-model:value="selected[index]"
        placeholder="请选择产品编号"
        @change="hadnleSelectSn"
        showSearch
        allowClear
        style="width: 200px"
      ></a-select> -->
      <a-input
        v-model:value="selected[index]"
        placeholder="请输入产品编号 例BCP240311A-001-001"
        @change="hadnleSelectSn"
        showSearch
        allowClear
        style="width: 370px"
        :disabled="props.disabled"
      ></a-input>
    </template>
  </a-space>
</template>

<script>
import { defineComponent, reactive, watch } from "vue";
import { getPQCList } from "@/request/view/dailyQualityInspection";
import { productOption } from "@/views/productDaily/components/instruction/option";

export default defineComponent({
  props: {
    requestConfig: Object,
    productNumberList: Object,
    disabled: Boolean,
  },
  setup(props, context) {
    const selected = reactive({});

    const selectOption = reactive([]);

    const getOption = () => {
      const { batchNumber, type } = props.requestConfig;
      selectOption.length = 0;
      getPQCList({
        type,
      }).then((res) => {
        if (res.code === 200 && res.message === "成功") {
          Object.keys(res.data).forEach((key) => {
            const list = res.data[key];
            list.forEach((item) => {
              selectOption.push({
                label: item.snNumber,
                value: item.snNumber,
              });
            });
          });
        }
      });
    };

    const hadnleSelectSn = () => {
      // 选择对象的键数组
      const keyList = Object.keys(selected);

      const list = [];

      keyList.forEach((key) => {
        list.push(selected[key]);
      });

      context.emit("selectProductNumberList", list);
    };

    // 重置选中数据
    const resetSelected = () => {
      Object.keys(selected).forEach((key) => {
        delete selected[key];
      });
    };

    // 设置数据
    const emptySelected = (num) => {
      console.log(props.requestConfig.type);
      
      let processNumber = '';

      if (props.requestConfig.type) {
        const processItem = productOption.find((f) => f.value === props.requestConfig.type);
        processNumber = processItem.number;
      }

      for (let i = 0; i < num; i += 1) {
        // selected[i] = null;
        // if (props.productNumberList && props.productNumberList[i]) {
        //   selected[i] = props.productNumberList[i];
        // }
        selected[i] = null;
        if (props.requestConfig && props.requestConfig.batchNumber && processNumber) {
          selected[i] = `${props.requestConfig.batchNumber}-${processNumber}`;
        }
      }
      hadnleSelectSn();
    };

    watch(
      () => props.requestConfig.num,
      (val, oldVal) => {
        if (val === oldVal) return;
        resetSelected();
        if (val && val > 0) {
          resetSelected();
          emptySelected(val);
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    // watch(
    //   () => props.requestConfig.type,
    //   (val) => {
    //     if (val) {
    //       getOption();
    //     }
    //   },
    //   {
    //     immediate: true,
    //     deep: true,
    //   }
    // );

    return {
      props,
      selected,
      selectOption,
      hadnleSelectSn,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
